/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsPublicServiceOutput } from "../../entities/models/PublicServiceOutput";
import { z } from "zod/v4";

export const modelsPublicServiceOutputSchema = z.object({
    "id": z.optional(z.int()),
"price": z.optional(z.number()),
"service_name": z.optional(z.string()),
"service_type": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsPublicServiceOutput>